export default {
  date: 'March 22, 2024',
  title: 'New styles for real estate developers: white box and grey shell!',
  description: 'We have created styles that showcase the potential of real estate in rough and finished finishes.',
  id: 'new-style-for-real-estate-developers',
  jsx: () => (
    <div class='novelty__text'>
      <p>
        Many property buyers prefer to see not only beautiful visualizations but also the actual space of their future home. Developers face the challenge of accurately conveying the real appearance and potential of properties during the development stage. The inability to view spaces in their true
        form slows down the sales process and can lead to misunderstandings between developers and buyers. In response to this, we are pleased to introduce our new product: virtual tour services available in White Box and Grey Shell formats.
      </p>
      <b>Why is this necessary?</b>
      <p>
        <u>Realism</u>: Showing real space helps buyers better understand and envision their future home or apartment.
        <br></br>
        <u>Immersion</u>: Virtual tours create deeper immersion in the space, facilitating faster decision-making.
        <br></br>
        <u>Time-saving</u>: Thanks to the absence of the need for physical visits, our virtual tours streamline the sales process for both your team and clients.
      </p>
      <b>Key Features:</b>
      <p>
        <u>Realistic Presentations</u>: Our tours accurately depict spaces in both White Box and Grey Shell formats.
        <br></br>
        <u>True-to-Life Representation</u>: Minimizing the gap between buyer expectations and reality by presenting properties in their natural state.
        <br></br>
        <u>Seamless Integration</u>: Our virtual tours are easy to integrate and use for your team and clients, ensuring smooth operation for all participants.
      </p>
      <p>Remember, the decision to purchase real estate is an important step, and transparency plays a key role in establishing trust with clients. By using our virtual tours, you can increase sales efficiency and customer satisfaction.</p>
      <p>Don't miss the opportunity to improve sales strategies and provide unparalleled clarity for your clients through our virtual tours!</p>
      <p>The new styles will be available in April 2023.</p>
    </div>
  ),
  thumb: 'news/9.webp',
};
